import React, { useRef } from 'react';
import { gsap } from 'gsap';
import Layout from '../components/Layout';

const Dev = () => {
  const cardRef = useRef(null);

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left - rect.width / 2;
    const y = e.clientY - rect.top - rect.height / 2;

    gsap.to(cardRef.current, {
      rotationX: y / 10,
      rotationY: x / 10,
      transformPerspective: 1000,
      ease: 'power3.out',
      duration: 0.5,
    });
  };

  const resetMousePosition = () => {
    gsap.to(cardRef.current, {
      rotationX: 0,
      rotationY: 0,
      ease: 'power3.out',
      duration: 0.5,
    });
  };

  return (
    <Layout>
      <div className="flex justify-center items-center p-4 relative shadow-2xl">
        {/* Card with Hover Effect */}
        <div
          ref={cardRef}
          className="card w-80 h-96 bg-[#177088] rounded-xl shadow-2xl shadow-[#063846] relative"
          onMouseMove={handleMouseMove}
          onMouseLeave={resetMousePosition}
        >
          {/* Lanyard */}
          <div className="lanyard w-8 h-8 bg-[#063846] rounded-full absolute top-[-32px] left-1/2 transform -translate-x-1/2"></div>
          <div className="lanyard-line w-2 h-8 bg-[#063846] absolute top-0 left-1/2 transform -translate-x-1/2"></div>

          <div className="card-border-top w-3/5 h-3 bg-[#063846] mx-auto rounded-b-xl"></div>
          <div className="img w-40 h-44 bg-[#063846] rounded-lg mx-auto mt-6 overflow-hidden">
            <img 
              src="gggg.png" 
              alt="Profile" 
              className="w-full h-full object-cover"
            />
          </div>
          <span className="font-semibold text-white text-center block pt-2 text-lg">Muhamad Irfan</span>
          <p className="job font-normal text-white text-center pt-1 text-sm">Information System Student</p>
          <button className="px-6 py-2 mt-8 mx-auto block rounded-md bg-[#063846] text-white font-semibold hover:bg-blue-300 animate-bounce">
            <a href='https://www.linkedin.com/in/mhdirfaan/' target='blank'>Click</a>
          </button>
        </div>
      </div>
    </Layout>
  );
};

export default Dev;
